import { Injectable } from '@angular/core'
import { FormState } from '@app/shared/models/form.model'
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita'
import { Filter, Project } from './project.model'

export interface ProjectsState extends EntityState<Project>, ActiveState {
  ui: {
    hasMoreItems: boolean
    searchQuery: string
    skipProjects: number
    filter: Filter
    projectFormState: FormState
  }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'projects', idKey: 'Id' })
export class ProjectsStore extends EntityStore<ProjectsState, Project> {
  constructor() {
    super({
      ui: {
        hasMoreItems: false,
        searchQuery: null,
        skipProjects: 0,
        filter: {
          availableUsers: [],
          selectedUser: null,
        },
        projectFormState: {
          isValid: true,
          isModified: false,
        },
      },
    })
  }
}
